// NutritionNormsList.jsx
import React from 'react';
import KitchenReferenceList from './KitchenReferenceList';

const NutritionNormsList = (props) => {
  return <KitchenReferenceList referenceType="nutrition-norms" {...props} />;
};

export default NutritionNormsList;